module.exports = __webpack_public_path__ + "static/img/1.1a9698c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R410A/1.jpg
// module id = Kasb
// module chunks = 1